"use client";

import { useRef } from "react";
import { motion, useScroll, useTransform, useMotionTemplate } from "framer-motion";

interface BlurRevealProps {
  children: React.ReactNode;
  className?: string;
}

export default function BlurReveal({ children, className = "" }: BlurRevealProps) {
  const ref = useRef(null);

  // Track the scroll progress of this specific element relative to the viewport
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"], // Starts when top enters bottom of screen, ends when bottom leaves top
  });

  // Map scroll progress (0 to 1) to blur values
  // 0% (enter) -> 10px blur
  // 35%-65% (center) -> 0px blur (clear)
  // 100% (exit) -> 10px blur
  const blurValue = useTransform(scrollYProgress, [0, 0.35, 0.65, 1], [10, 0, 0, 10]);
  const opacityValue = useTransform(scrollYProgress, [0, 0.35, 0.65, 1], [0, 1, 1, 0]);
  
  // Create the filter string
  const blurFilter = useMotionTemplate`blur(${blurValue}px)`;

  return (
    <motion.div
      ref={ref}
      style={{ 
        position: "relative",
        filter: blurFilter, 
        opacity: opacityValue 
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
